import { render } from "./GlobalWidgetFooterEditor.vue?vue&type=template&id=67432ced"
import script from "./GlobalWidgetFooterEditor.vue?vue&type=script&lang=js"
export * from "./GlobalWidgetFooterEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__